/**
 * @generated SignedSource<<cd3d6a5a9e70d818dfb736d075bb85ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoResponseType = "IMAGES" | "NUMBER" | "TEXT";
export type WorkspaceTodoEditMainResponseTypeMutation$variables = {
  id: string;
  responseType?: TodoResponseType | null;
};
export type WorkspaceTodoEditMainResponseTypeMutation$data = {
  readonly todoWorkspace: {
    readonly updateResponseType: {
      readonly id: string;
      readonly responseType: TodoResponseType | null;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainResponseType_TodoWorkspace">;
    };
  };
};
export type WorkspaceTodoEditMainResponseTypeMutation$rawResponse = {
  readonly todoWorkspace: {
    readonly updateResponseType: {
      readonly id: string;
      readonly responseDescription: string | null;
      readonly responseType: TodoResponseType | null;
      readonly updatedAtDate: {
        readonly __isDate: "UnzonedDate";
        readonly isoString: string;
      } | null;
      readonly updatedBy: {
        readonly id: string;
        readonly name: string;
      } | null;
    };
  };
};
export type WorkspaceTodoEditMainResponseTypeMutation = {
  rawResponse: WorkspaceTodoEditMainResponseTypeMutation$rawResponse;
  response: WorkspaceTodoEditMainResponseTypeMutation$data;
  variables: WorkspaceTodoEditMainResponseTypeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "responseType"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "newResponseType",
    "variableName": "responseType"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoEditMainResponseTypeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateResponseType",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceTodoEditMainResponseType_TodoWorkspace"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoEditMainResponseTypeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateResponseType",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "responseDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isoString",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c5bb7deaf8c9ebea5065751687cf0f4",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoEditMainResponseTypeMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoEditMainResponseTypeMutation(\n  $id: ID!\n  $responseType: TodoResponseType\n) {\n  todoWorkspace(id: $id) {\n    updateResponseType(newResponseType: $responseType) {\n      id\n      responseType\n      ...WorkspaceTodoEditMainResponseType_TodoWorkspace\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceTodoEditMainResponseType_TodoWorkspace on TodoWorkspace {\n  id\n  responseType\n  responseDescription\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n  updatedBy {\n    name\n    id\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "f27dcf50b7e1193aff56fd7e9a93b2fe";

export default node;
